'use client'

import { createContext, useContext } from 'react'

// REVIEWS_HIGHLIGHT and REVIEWS_LIST are shared by REVIEWS_MINI and REVIEWS_FULL but render
// differently per surface (mini = condensed highlights, no rating bars; full = summary bars +
// rich list with filters/sort). The container provides the surface via context so the shared
// child widgets can adapt without knowing their parent widget type.
export type ReviewsVariant = 'mini' | 'full'
export const ReviewsVariantContext = createContext<ReviewsVariant>('full')
export const useReviewsVariant = (): ReviewsVariant => useContext(ReviewsVariantContext)

// Shared spid holder: the review list/gallery items carry `productId`; whichever renders first
// publishes it here. (Write-a-review now reads the product id directly from the PL layout context —
// `context.pdp.productIds.productId` — so this holder is retained only for any spid-based consumers.)
export interface ReviewsProductContextValue {
  spid: string | null
  publishSpid: (spid: string) => void
}
export const ReviewsProductContext = createContext<ReviewsProductContextValue | null>(null)
export const useReviewsProduct = (): ReviewsProductContextValue | null => useContext(ReviewsProductContext)
